import { eur } from "@/lib/api";
import { useT } from "@/i18n";

export function QuoteTable({ quote, compact = false }) {
  const { t } = useT();
  return (
    <div data-testid="quote-table">
      <table className="w-full text-sm">
        <thead><tr className="text-left text-xs uppercase tracking-wider text-ink/50 border-b border-craft"><th className="py-2">{t("quote.item")}</th><th className="py-2 text-right">{t("quote.qty")}</th><th className="py-2 text-right">{t("quote.price")}</th><th className="py-2 text-right">{t("quote.total")}</th></tr></thead>
        <tbody>
          {quote.items.map((it, i) => (
            <tr key={`${it.description}-${it.qty}-${it.unit_price}-${i}`} className="border-b border-craft/60"><td className="py-2.5">{it.description}</td><td className="py-2.5 text-right font-mono">{it.qty}</td><td className="py-2.5 text-right font-mono">{eur(it.unit_price)}</td><td className="py-2.5 text-right font-mono">{eur(it.qty * it.unit_price)}</td></tr>
          ))}
        </tbody>
      </table>
      <dl className={`mt-4 ml-auto ${compact ? "max-w-xs" : "max-w-sm"} space-y-1.5 text-sm`}>
        <Row l={t("quote.subtotal")} v={eur(quote.subtotal)} />
        <Row l={t("quote.vat", { rate: quote.vat_rate })} v={eur(quote.vat)} />
        <Row l={t("quote.total")} v={eur(quote.total)} bold />
        {quote.inspection_credit > 0 && <Row l={t("quote.credit")} v={`− ${eur(quote.inspection_credit)}`} accent />}
        <Row l={t("quote.due")} v={eur(quote.amount_due)} bold big testId="quote-amount-due" />
        <div className="pt-2 mt-2 border-t border-craft text-xs text-ink/60">
          {quote.deposit_pct >= 100 ? t("quote.full") : t("quote.split", { pct: quote.deposit_pct, dep: eur(quote.deposit_amount), bal: eur(quote.balance_amount) })}
        </div>
      </dl>
      {quote.notes && <p className="mt-4 text-sm text-ink/60 whitespace-pre-line" data-testid="quote-notes">{quote.notes}</p>}
    </div>
  );
}

function Row({ l, v, bold, big, accent, testId }) {
  return <div className={`flex justify-between ${bold ? "font-semibold" : ""} ${big ? "text-lg" : ""} ${accent ? "text-forest" : ""}`}><dt>{l}</dt><dd className="font-mono" data-testid={testId}>{v}</dd></div>;
}
